/**
 * @generated SignedSource<<9742142295c73619159a143ccb00b791>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "Schedule",
            "kind": "LinkedField",
            "name": "schedule",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditScheduleModalGeneralTabQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditScheduleModalGeneralTabQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "25bcc08fec8ee1a8d9ac0275e0b8c193",
            "id": null,
            "metadata": {},
            "name": "EditScheduleModalGeneralTabQuery",
            "operationKind": "query",
            "text": "query EditScheduleModalGeneralTabQuery(\n  $id: ID!\n) {\n  schedule(id: $id) {\n    id\n    name\n  }\n}\n"
        }
    };
})();
node.hash = "1dc982576c7ddef7ee4800b52f9bd0f7";
export default node;
